import React from 'react';
import { FilterTiles } from '@spins/react-ui-library';
import { QueryStateFiltering } from '@spins/react-table';
import './styles.scss';

interface Props {
  filtering: QueryStateFiltering;
}

const formatType = (type: string): string => {
  switch (type) {
    case 'lt':
      return 'less than';
    case 'eq':
      return 'equals';
    case 'neq':
      return 'not equal';
    case 'gt':
      return 'greater than';
  }
  return '';
};

const TableFilterTiles: React.FC<Props> = ({ filtering }) => {
  const getFilterTiles = () => {
    return filtering.filters.map((filter) => ({
      id: `${filter.id}-${filter.type}`,
      label: `${filter.label} ${formatType(filter.type)} ${filter.value}`,
      variant: 'none',
      onClick: () => filtering.removeFilter(filter),
    }));
  };
  return (
    <div className={'filter-tiles-container'}>
      <FilterTiles
        clearAllClassName={'custom-clear-all-tile'}
        filterTileClassName={'custom-filter-tile'}
        tiles={[...getFilterTiles()]}
        onClearAll={() => filtering.removeAll()}
      />
    </div>
  );
};

export default TableFilterTiles;
